/*
 * Copyright 2025 Intuition Robotics ltd
 */
import __asset_0 from "@res/icons/trash.svg";
import {DeleteReminderDialog} from "./DeleteReminderDialog";
import {FONTS} from "@res/fonts";
import * as React from "react";
import {DB_Patient} from "@app/app-shared/patient";
import {Reminder} from "@app/app-shared/reminder";
import {hideTooltip} from "../../widget/appTooltip";
import {showDialog} from "../../widget/DialogCard";

const trash = __asset_0;

type Props = {
    patient: DB_Patient
    reminder: Reminder
}

export class EditReminderTooltip
    extends React.Component<Props> {

    private ref = React.createRef<HTMLDivElement>();

    closeListener = (e: KeyboardEvent) => {
        if (e.key === "Escape")
            hideTooltip();
    }

    clickListener = (e: MouseEvent) => {
        // @ts-ignore
        if (this.ref.current && !this.ref.current.contains(e.target))
            hideTooltip();
    }

    componentDidMount() {
        window.addEventListener('keydown', this.closeListener)
        window.addEventListener('mouseup', this.clickListener)
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.closeListener);
        window.removeEventListener("mouseup", this.clickListener);
    }

    render() {
        return <div ref={this.ref}>
            <div className={"clickable"} style={{display: "flex", alignItems: "center", cursor: "pointer"}}
                 onClick={() => {
                     hideTooltip();
                     showDialog(<DeleteReminderDialog patient={this.props.patient} reminder={this.props.reminder}/>);
                 }}>
                <img src={trash}
                     className={"clickable"}
                     alt="trash"
                     style={{marginRight: 10}}
                     height={20}
                     width={20}/>
                {FONTS.reg_14("Delete reminder")}
            </div>
        </div>;
    }
}
